import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Lock } from "lucide-react";
import { AuthShell, Field } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Parolele nu coincid.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: password });
      toast.success("Parola a fost schimbata. Te poti autentifica.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Link invalid sau expirat.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Parola noua" subtitle="Alege o parola noua pentru contul tau StockMusic.ro.">
      <form onSubmit={submit} className="space-y-4">
        <Field icon={Lock} type="password" placeholder="Parola noua" value={password} setValue={setPassword} testid="reset-password" />
        <Field icon={Lock} type="password" placeholder="Confirma parola" value={confirm} setValue={setConfirm} testid="reset-confirm" />
        <button disabled={busy || !token} className="w-full rounded-full bg-[#D4A23A] py-3 font-semibold text-black transition hover:bg-[#E2B85C] disabled:opacity-60">
          {busy ? "Se salveaza..." : "Schimba parola"}
        </button>
      </form>
      {!token && <p className="mt-4 text-center text-sm text-red-300">Token lipsa. Cere un link nou de resetare.</p>}
      <p className="mt-6 text-center text-sm text-zinc-500">
        <Link to="/forgot-password" className="text-[#D4A23A] hover:underline">Cere alt link</Link>
      </p>
    </AuthShell>
  );
}
